import { put, SagaGenerator, select, takeLatest } from "typed-redux-saga";

import { ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { FormActivity } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";

import { createEventButtonActionMatcher } from "../../../../utilities/actionUtils";
import { isDocumentWithProcessMetadata } from "../../../workflows/data/processMetadata";
import { selectLastCreatedProcessBusinessKey } from "../../../../app/slices/operation/selectors";
import { setLastCreatedProcessBusinessKey } from "../../../../app/slices/operation/reducers";
import { TASK_DETAIL_ACTIVITY_ID } from "../../../processOverview/store/actions";
import { createCustomNotificationAction } from "../../../../app/actions";
import { RESOURCE_KEYS } from "../../../../localization";

export function* cancelNewAntragSaga(): SagaGenerator<void> {
	yield* takeLatest(createEventButtonActionMatcher("event_cancel"), function* (action) {
		const activity = yield* select(ActivitySelectors.activityById(action.payload.activityId));
		const activityId = action.payload.activityId;
		if (activityId !== TASK_DETAIL_ACTIVITY_ID || activity?.descriptor.view !== "Task") {
			return;
		}
		const data = yield* select(ActivitySelectors.data(action.payload.activityId));
		if (!data || !FormActivity.Data.SingleDocumentData.isInstance(data)) {
			return;
		}

		const document = data.document;
		if (!isDocumentWithProcessMetadata(document)) {
			return;
		}

		const lastCreatedProcessBusinessKey = yield* select(selectLastCreatedProcessBusinessKey());
		if (!document.root.processMetadata.vorgangsnummer && lastCreatedProcessBusinessKey === document.id) {
			yield* put(
				createCustomNotificationAction({
					title: { key: RESOURCE_KEYS.features.notification.title.info },
					message: { key: RESOURCE_KEYS.features.notification.success.newAntrag },
					icon: "done",
					severity: "success",
					group: `neuerAntrag:${lastCreatedProcessBusinessKey}`
				})
			);
		}
		yield* put(setLastCreatedProcessBusinessKey({ lastCreatedProcessBusinessKey: "" }));
	});
}
